import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder"

export default class LocationSearch {
	// https://docs.mapbox.com/help/tutorials/building-a-store-locator/
	// https://docs.mapbox.com/mapbox-gl-js/api/map/#map#addlayer
	constructor(hook) {
		this.hook = hook;
		this.el = hook.el;

		this.coords = this.el.dataset.coords
			.replaceAll(" ", "")
			.trim()
			.split(",")

		this.map = new mapboxgl.Map({
			container: this.el.querySelector(".map"),
			style: "mapbox://styles/noppo/clgowlrzt00hp01r7bqrdc05w",
			center: [this.coords[1], this.coords[0]],
			zoom: 13,
			scrollZoom: false
		});

		this.geocoder = new MapboxGeocoder({
			accessToken: mapboxgl.accessToken,
			mapboxgl: mapboxgl,
			marker: true
		});

		this.map.addControl(this.geocoder, "top-left");

		// fetch("/api/locations").then(response => {
		//   if (response.ok) {
		//     response.json().then(data => {
		//       this.convertData(data.data);

		//       if (this.map.loaded()) {
		//         this.initMap();
		//       } else {
		//         this.map.on("load", () => this.initMap());
		//       }
		//     });
		//   }
		// })
	}

	convertData(data) {
		const locations = [];

		data.forEach(item => {
			const loc = item.attributes;
			const coords = loc.attrs.coord.split(",");

			locations.push({
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [
						coords[1].trim(),
						coords[0].trim(),
					]
				},
				"properties": {
					"id": loc.id,
					"name": loc.title,
					"address": loc.attrs["address"]
				}
			});
		});

		this.locations = locations;
	}

	initMap() {
		const locations = {
			"type": "FeatureCollection",
			"features": this.locations
		};

		this.map.addSource("places", {
			type: "geojson",
			data: locations
		});

		this.addMarkers();

		this.map.addControl(new mapboxgl.NavigationControl({
			visualizePitch: true
		}), "bottom-left");
	}

	addMarkers() {
		for (const marker of this.locations) {
			const el = document.createElement("div");
			el.dataset.id = marker.properties.id;
			el.className = 'marker';

			new mapboxgl.Marker(el, { offset: [0, -23] })
				.setLngLat(marker.geometry.coordinates)
				.addTo(this.map);

			el.addEventListener("click", (e) => {
				const button = document.querySelector(`.map-results button[value="${e.target.dataset.id}"]`);
				if (button) {
					this.el.dispatchEvent(new CustomEvent("map:flyTo", { detail: { dispatcher: button } }));
				}
			});
		}
	}

	addListeners() {
		this.el.addEventListener("map:flyTo", e => {
			e.preventDefault();

			for (const loc of this.locations) {
				const button = e.detail.dispatcher;

				if (loc.properties.id === button.value) {
					for (const item of button.closest(".map-results").querySelectorAll(".result")) {
						item.classList.remove("active");
					}
					button.classList.add("active");

					this.flyTo(loc);
					this.createPopUp(loc);
				}
			}
		});

		this.geocoder.on("result", event => {
			this.findClosest(event.result.geometry);
		});
	}

	findClosest(searchResult) {
		const options = { units: "kilometers" };

		for (const loc of this.locations) {
			loc.properties.distance = turf.distance(searchResult, loc.geometry, options);
		}

		this.locations.sort((a, b) => {
			if (a.properties.distance > b.properties.distance) {
				return 1;
			}
			if (a.properties.distance < b.properties.distance) {
				return -1;
			}
			return 0;
		});

		const container = this.el.closest(".map-select");
		const shortLocations = [];

		for (const shortLoc of this.locations) {
			const distance = shortLoc.properties.distance;

			shortLocations.push({
				id: shortLoc.properties.id,
				distance: distance < 1 ? Math.round(distance * 100) : Math.round(distance),
				unit: distance < 1 ? "m" : "km"
			});
		}

		this.hook.pushEventTo(container, "sort-locations", shortLocations);

		const bbox = this.getBbox(this.locations[0], searchResult);
		this.createPopUp(this.locations[0]);
		this.map.fitBounds(bbox, { padding: 100 });
	}

	flyTo(currentFeature) {
		this.map.flyTo({
			center: currentFeature.geometry.coordinates,
			zoom: 15
		});
	}

	createPopUp(currentFeature) {
		const popUps = document.getElementsByClassName('mapboxgl-popup');

		if (popUps[0]) {
			popUps[0].remove();
		}

		new mapboxgl.Popup({ closeOnClick: false })
			.setLngLat(currentFeature.geometry.coordinates)
			.setHTML(`<h3>${currentFeature.properties.name}</h3><h4>${currentFeature.properties.address}</h4>`)
			.addTo(this.map);
	}

	getBbox(loc, searchResult) {
		const lats = [
			loc.geometry.coordinates[1],
			searchResult.coordinates[1]
		];

		const lons = [
			loc.geometry.coordinates[0],
			searchResult.coordinates[0]
		];

		const sortedLons = lons.sort((a, b) => {
			if (a > b) {
				return 1;
			}
			if (a.distance < b.distance) {
				return -1;
			}
			return 0;
		});

		const sortedLats = lats.sort((a, b) => {
			if (a > b) {
				return 1;
			}
			if (a.distance < b.distance) {
				return -1;
			}
			return 0;
		});

		return [
			[sortedLons[0], sortedLats[0]],
			[sortedLons[1], sortedLats[1]]
		];
	}
}
